import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-620290f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container position-relative custom-background-height py-5 mt-3" }
const _hoisted_2 = { class: "d-flex col-12 col-md-10 col-lg-9 mx-auto" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "row gx-5 pb-5 px-0 px-lg-3 border border-top-0 border-end-0 border-start-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-primary fw-normal col-11 col-md-9 col-lg-12 mx-auto mb-5" }, " Edit Project ", -1))
const _hoisted_6 = { class: "col-11 col-md-9 col-lg-6 mx-auto mb-5 mb-lg-0" }
const _hoisted_7 = { class: "col-11 col-md-9 col-lg-6 mx-auto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-3" }, "Services:", -1))
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, null, -1))
const _hoisted_12 = { class: "text-end pt-3" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "fa fa-spinner fa-spin",
  "aria-hidden": "true"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check ps-3",
  "aria-hidden": "true"
}, null, -1))

import router from "@/router";
import { storeToRefs } from "pinia";
import { impalaApi } from "@/main.ts";
import { useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import { editProjectObject } from "@/interfaces";
import { useClientStore } from "@/store/ClientStore";
import { ref, reactive, watch, onBeforeMount } from "vue";
import BaseTextarea from "@/components/base-components/BaseTextArea.vue";
import BaseInputUnderline from "@/components/base-components/BaseInputUnderline.vue";


const __default__ = {
  name: "Edit",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const id = ref();
const store = useClientStore();
const services = ref(null);
const loading = ref(false);
const clientSubscribed = ref(false);
const { clientData, pageLoading } = storeToRefs(store);
const route = useRoute();
const form = reactive({}) as editProjectObject;

onBeforeMount(async () => {
  pageLoading.value = true;
  id.value = route.query.id;
  try {
    const { data: project } = await impalaApi.get(
      `/client-dashboard/projects/${id.value}`
    );
    form.clientName = project.clientName;
    form.services = project.services;
    form.ownerEmail = project.ownerEmail;
    form.projectName = project.projectName;
    form.description = project.description;
    if (clientSubscribed.value) {
      form.maxAllowedRespondents = project.maxAllowedRespondents;
    }
    const { data: servicesData } = await impalaApi.get(
      "/client-dashboard/services"
    );
    services.value = servicesData;
  } catch (error) {
    console.error(error);
  }
  pageLoading.value = false;
});

watch(clientData, (data) => {
  if (data === null) return;
  clientSubscribed.value =
    clientData.value?.clientType === "Subscribed" ?? false;
});

const submit = async () => {
  if (clientSubscribed.value) {
    delete form.maxAllowedRespondents;
  }
  console.log(form);
  try {
    loading.value = true;
    await impalaApi.put(`/client-dashboard/projects/${id.value}`, form);
    await router.push("/projects");
    toast.success(
      'Project "' + form.projectName + '" was updated successfully!'
    );
  } catch (error: never) {
    toast.error(
      'Project "' +
        form.projectName +
        '" update failed! : ' +
        error.response?.data
    );
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"]),
        role: "form",
        class: "ui form bg-light w-100 pt-5 px-1 px-md-4 pb-3 rounded-4 shadow"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (clientSubscribed.value)
              ? (_openBlock(), _createBlock(BaseInputUnderline, {
                  key: 0,
                  value: _unref(form).maxAllowedRespondents,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).maxAllowedRespondents) = $event)),
                  name: "create-project-max-allowed-respondents",
                  type: "number",
                  id: "create-project-total-respondents",
                  "aria-placeholder": "What do you think?",
                  label: "Total Number of Respondents:",
                  required: ""
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _createVNode(BaseInputUnderline, {
              value: _unref(form).clientName,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).clientName) = $event)),
              name: "create-project-client-name",
              type: "text",
              id: "create-project-client-name",
              "aria-placeholder": "What do you think?",
              label: "Client Name:",
              required: ""
            }, null, 8, ["value"]),
            _createVNode(BaseInputUnderline, {
              value: _unref(form).projectName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).projectName) = $event)),
              name: "create-project-name",
              type: "text",
              id: "create-project-name",
              "aria-placeholder": "What do you think?",
              label: "Project Name:",
              required: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseTextarea, {
              value: _unref(form).description,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).description) = $event)),
              name: "create-project-description",
              id: "create-project-description",
              label: "Description:"
            }, null, 8, ["value"]),
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "btn-check",
                  id: service.id,
                  value: service.serviceName.toLowerCase(),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).services) = $event)),
                  name: "services"
                }, null, 8, _hoisted_9), [
                  [_vModelCheckbox, _unref(form).services]
                ]),
                _createElementVNode("label", {
                  class: "btn btn-outline-primary rounded-pill col-10 col-sm-8 mb-3 py-1",
                  for: service.id
                }, _toDisplayString(service.serviceName), 9, _hoisted_10),
                _hoisted_11
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: { name: 'Project', params: { projectId: id.value } },
            class: "btn btn-info text-light rounded-pill text-secondary px-4 me-sm-3 m-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Preview ")
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("button", {
            type: "submit",
            disabled: loading.value,
            class: "ui button btn-send btn btn-primary text-light rounded-pill px-3 m-1"
          }, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_14))
              : _createCommentVNode("", true),
            _createTextVNode(" Save "),
            _hoisted_15
          ], 8, _hoisted_13)
        ])
      ], 40, _hoisted_3)
    ])
  ]))
}
}

})